import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import TableHeaderCellContainer from './TableHeader/TableHeaderCellContainer';
import Pagination from './Pagination/Pagination';
import NoOffers from '../NoOffers/NoOffers';
import { connect } from 'react-redux';
import { vehicleTypes } from '../../consts/vehicleTypes';

const Table = (props) => {
  const [tableHeight, setTableHeight] = useState('')
  const {
    whichFolder,
    tableHeaders,
    fetchOffers,
    totalPages,
    totalCount,
    isMobile,
    vehicleType,
  } = props;
  const isNoOffers = totalCount === 0;


  useEffect(() => {
    fetchOffers()
    const interval = setInterval(fetchOffers, 30000)
    setTimeout(() => window.requestAnimationFrame(computeTableHeight), 1000);
    return () => {
      clearInterval(interval);
    }
  }, [vehicleType])

  const computeTableHeight = () => {
    const headerHeight = document.querySelector('.dealers-header')?.offsetHeight;
    const breadcrumbsHeight = document.querySelector('.main-area__header')?.offsetHeight;

    // 72px is pagination height
    setTableHeight(`calc(100vh - 72px - ${headerHeight + breadcrumbsHeight}px)`);
  }

  const renderTableHead = () => {
    return (
      <thead>
        <tr className={`tr-${whichFolder}`}>
          {Object.entries(tableHeaders).map(([label, isSortable]) => (
            <TableHeaderCellContainer
              key={label}
              label={label}
              tableName={whichFolder}
              fetchOffers={fetchOffers}
              isSortable={isSortable}
            />
          ))}
        </tr>
      </thead>
    );
  }


  const renderTableRows = () => {
    const { onRowClick, renderRow, items, rowClasses, } = props;
    if (!items) {
      return null
    }

    return items.map((item) => {
      const isNew = get(item, 'bold') || get(item, 'seen_by_dealer') === false;
      const rowContainerClasses = classNames(
        `row-container tr-${whichFolder}`,
        { 'strong-size': isNew, },
        rowClasses
      );
      const rowId = (['ads', 'invoices'].includes(whichFolder) ? get(item, 'id') : get(item, 'hash_id'));
      return (
        <tr
          className={rowContainerClasses}
          key={rowId}
          onClick={() => onRowClick && onRowClick(rowId, whichFolder)}
        >
          {renderRow(item)}
        </tr>
      );
    });
  }

  return (
    <div className="row">
    <div id="table" className="col-md-12 right-column main-area table-responsive" style={{ height: tableHeight, }}>
      <table className="table">
        {!isMobile && renderTableHead()}
        <tbody>
          {isNoOffers
            ? <NoOffers whichFolder={whichFolder} />
            : renderTableRows()
          }
        </tbody>
      </table>
    </div>
    {!isNoOffers &&
      <Pagination
        tableName={whichFolder}
        totalCount={totalCount}
        totalPages={totalPages}
        fetchOffers={fetchOffers}
      />}
  </div>
  )
}

Table.propTypes = {
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)).isRequired,
  whichFolder: PropTypes.string.isRequired,
  fetchOffers: PropTypes.func,
  tableHeaders: PropTypes.object,
  totalCount: PropTypes.number,
  totalPages: PropTypes.number,
  renderRow: PropTypes.func,
  onRowClick: PropTypes.func,
  rowClasses: PropTypes.string,
  isMobile: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object.isRequired),
};

Table.defaultProps = {
  fetchOffers: null,
  isMobile: true,
  tableHeaders: {},
  totalCount: 0,
  totalPages: 1,
  renderRow: null,
  onRowClick: null,
  items: null,
  rowClasses: '',
};

const mapStateToProps = (state) => {
  return {
    isMobile: get(state, ['layout', 'isMobile']),
    vehicleType: state.vehicleType.vehicleType,
  };
};

export default connect(mapStateToProps)(Table);
